import { Yield } from '../../abacus/interfaces/yield.interface'

export const toolCountryYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  }
]
